// Hardcoded UTM source -> medium mapping for Captain app campaigns.
// Per product spec, options and mappings are NOT editable in-app; they change only
// through engineering releases. The UTM source dropdown offers exactly these sources,
// and the UTM medium dropdown offers exactly the mediums mapped to the selected source.
//
// RP-4026: full replacement of the previous 45-source list with marketing's V2 set.
// The sheet supplies display labels only, so the slugs below are derived from them
// (lowercased, non-alphanumerics collapsed to underscores). Order follows the sheet.
export const CAMPAIGN_UTM_SOURCE_MEDIUMS: { [source: string]: string[] } = {
  // Partner Marketing
  partner_marketing: [
    'a_frame_sign',
    'billboard',
    'business_card',
    'direct_mail',
    'event_booth',
    'postcard',
    'poster',
    'flyer',
    'magnet_sticker',
    'radio_ad',
    'yard_sign',
    'window_decal',
    'social_media',
    'paid_social_media',
    'paid_ads',
    'charity_email',
    'in_store_screen',
    'door_tag',
    'mission_spotlight',
    'landing_page',
    'website_popup_banner',
    'faq',
    'blog',
    'tax_receipt_slips',
    'custom_digital',
    'custom_physical',
    'employee_training_resource',
    'embedded_charity_widget',
    'podcast_mention',
    'charity_sms',
    'truck_wrap',
    'ad_grants_unbounce_page',
    'unbounce_page',
  ],
  // PR
  pr: ['magazine', 'news_mention', 'press_release'],
  // Referral
  referral: [
    'online_resource_page',
    'radio_ad',
    'municipal_dpw_partner_website',
    'realtor_website',
    'chamber_of_commerce',
    'resupply_partner_portal',
    'uber_partnership',
    'college_university_website',
    'nursing_home',
  ],
  // SMS/Email
  sms_email: ['sms', 'survey_email', 'donor_newsletter', 'push_notification'],
  // Event Marketing
  event_marketing: ['event_poster', 'event_handout'],
  // ReSupply Website
  resupply_website: ['campaign_landing_page', 'donor_support_page', 'blog'],
};

export const CAMPAIGN_UTM_SOURCES: string[] = Object.keys(CAMPAIGN_UTM_SOURCE_MEDIUMS);

export const campaignUtmMediumsForSource = (source?: string | null): string[] =>
  source ? (CAMPAIGN_UTM_SOURCE_MEDIUMS[source] ?? []) : [];

export const isValidCampaignUtmSource = (source?: string | null): boolean => !!source && !!CAMPAIGN_UTM_SOURCE_MEDIUMS[source];

export const isValidCampaignUtmMedium = (source?: string | null, medium?: string | null): boolean =>
  !!medium && campaignUtmMediumsForSource(source).includes(medium);
